export default "__VITE_ASSET__POaIRldO__";